import { useState, useEffect, useContext } from 'react'
import ContextStates from '../context/ContextStates';
import { FaEye, FaPen, FaTrash } from "react-icons/fa";
import axios from 'axios'
import { Url } from './Url';


const ListMisPedidos = () => {
    const [pedidos, setPedidos] = useState([])
    const { modify, setPedidoSelected, setFormView, setViewOpen, cliente } = useContext(ContextStates)

    useEffect(() => {
        const consultaPedidos = async () => {
            if (cliente) {
                const formData = new FormData()
                console.log("cliente ",cliente.id)
                formData.append("idcliente", cliente.id)
    
                try {
                    const response = await axios({
                        url: Url + 'api/listadompedidos.php',
                        method: 'POST',
                        data: formData,
                    })
                    console.log("a ver que pasa ahora ",response)
                    setPedidos(response.data.results)
                } catch (e) {
                    console.log(e)
                }    
            }
        }
        consultaPedidos()
    }, [])


    const handleView = (item, action) => {
        //console.log(item)
        setPedidoSelected(item)
        setFormView(action)
        setViewOpen(true)
    }


    return (
        <div className="w-full py-5 px-2 md:px20 rounded-2xl">
            <div className="sm:items-start">
                <table className='w-full'>
                    <thead>
                        <tr className='p-1 bg-blue-400 text-white'>
                            <th className='px-2'>Número</th>
                            <th className='px-2'>Fecha</th>
                            <th className='px-2'>Hora</th>
                            <th className='px-2'>Hora de entrega</th>
                            <th className='px-2'>Estado</th>
                            <th className='px-2'>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pedidos && (
                            pedidos.map((item, index) => (
                                <tr key={index} className={`border border-gray-300 p-2 hover:cursor-pointer ${item.stockmin > item.stock ? 'bg-red-100' : index % 2 === 0 ? 'bg-white hover:bg-slate-200' : 'bg-slate-100 hover:bg-slate-200'}`}>
                                    <td className='text-center'>{item.numero}</td>
                                    <td className='text-center'>{item.fecha}</td>
                                    <td className='text-center'>{item.hora}</td>
                                    <td className='text-center'>{item.horaespecifica}</td>
                                    <td className={`text-center ${item.estado === '1' ? 'bg-orange-400 text-white' : item.estado === '2' ? 'bg-yellow-400 text-black' : item.estado === '3' ? 'bg-green-400 text-gray-600' : item.estado === '4' && 'bg-cyan-400 text-gray-800'}`}>{item.estadopedido}</td>
                                    <td className='text-center'>
                                        <button className='bg-blue-500 ml-2 hover:bg-blue-300 rounded p-2 text-white' onClick={() => handleView(item, 120)}><FaEye /></button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default ListMisPedidos